import { getApi } from "./util/getApi";

const fetchURL = process.env.REACT_APP_API_URL + "/payment";

const api = getApi(fetchURL);

export const createPaymentIntent = async (
  amount: number,
  currency: string = "usd",
  metadata?: Record<string, string | number>
) => {
  const res = await api.post("/create-payment-intent", {
    amount,
    currency,
    metadata,
  });

  return res.data;
};
